var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.86 25.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.9;}.cls-2,.cls-3{fill:#d7bb2a;strokeLinecap:round;strokeLinejoin:round;fillRule:evenodd;}.cls-2{stroke:#d7bb2a;}.cls-3{stroke:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stars") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.28,5.27a.7.7,0,0,1,.63.39l2,4.1,4.52.66a.7.7,0,0,1,.57.49.68.68,0,0,1-.18.72l-3.27,3.19.77,4.51a.7.7,0,0,1-.28.69.72.72,0,0,1-.75.06l-4-2.13-4,2.13A.72.72,0,0,1,7.48,20a.7.7,0,0,1-.28-.69L8,14.82,4.7,11.63a.72.72,0,0,1-.18-.72.7.7,0,0,1,.57-.49l4.53-.66,2-4.1A.71.71,0,0,1,12.28,5.27Zm0,2.31-1.56,3.14a.69.69,0,0,1-.53.39l-3.48.51,2.52,2.45a.68.68,0,0,1,.2.62l-.59,3.46L12,16.52a.7.7,0,0,1,.66,0l3.1,1.63-.59-3.46a.71.71,0,0,1,.2-.62l2.52-2.45-3.48-.51a.69.69,0,0,1-.53-.39Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.21,18.74a1.4,1.4,0,0,1,.26-2L19.73,6.42a1.41,1.41,0,0,1,1.92.48,1.4,1.4,0,0,1-.26,2L6.13,19.23A1.41,1.41,0,0,1,4.21,18.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenStar);
export default __webpack_public_path__ + "static/media/BrokenStar.e9503ce7cc1abc33b28418c64445f7fc.svg";
export { ForwardRef as ReactComponent };